import { render, staticRenderFns } from "./SettingsPriceTemplateDetails.vue?vue&type=template&id=b1d47e12&scoped=true&"
import script from "./SettingsPriceTemplateDetails.vue?vue&type=script&lang=ts&"
export * from "./SettingsPriceTemplateDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d47e12",
  null
  
)

export default component.exports